import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {CodePipeline} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {formatTimestamp} from "../../../../utils/TableTimestamps.tsx";
import config from "../config";


export const useCodePipelinesTableColumns = () => {

    const columns: DataTableColumn<CodePipeline>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            sortable: true,
            render: (item: CodePipeline) => <NavLink
                to={`${config.basePath}/${encodeURIComponent(item.name)}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'lastExecutionStatus',
            title: I18n.get('Last Execution Status'),
            width: '1fr',
            sortable: true,
            render: (item: CodePipeline) => item.lastExecutionStatus ?? '-',
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            sortable: true,
            render: (item: CodePipeline) => formatTimestamp(item.created),
        },
    ];

    return {
        columns,
    };
};
